import { classNames } from '../utilities';

export const PatientIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames('', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      width="20"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.08884 11.2712C2.9138 11.2712 2.76707 11.2058 2.64867 11.0751C2.53026 10.9443 2.47106 10.7823 2.47106 10.589V9.43223H11.1131L11.3347 9.67695V2.69915H12.3822C12.5573 2.69915 12.704 2.76453 12.8224 2.89528C12.9408 3.02604 13 3.18806 13 3.38135V14L10.5289 11.2712H3.08884ZM0 10.6187V0.682216C0 0.488916 0.0592026 0.326889 0.177608 0.196134C0.296013 0.0653784 0.442736 0 0.617778 0H9.32027C9.4953 0 9.64202 0.0653784 9.76042 0.196134C9.87883 0.326889 9.93803 0.488916 9.93803 0.682216V7.20765C9.93803 7.40094 9.87883 7.56296 9.76042 7.69372C9.64202 7.82447 9.4953 7.88985 9.32027 7.88985H2.47106L0 10.6187ZM8.89052 6.73308V1.15677H1.04751V7.26703L1.53101 6.73308H8.89052Z"
        fill="#666666"
      />
    </svg>
  );
};
